




import Vue from 'vue'
import { SoundElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'SoundEl',
  props: {
    templateItemData: {
      type: Object as () => SoundElInterface,
      required: true
    }
  },
  data: () => ({
    playCount: 0
  }),
  mounted () {
    this.hideElement()

    if (this.shouldPlay()) {
      this.playSound()
    }
  },
  methods: {
    hideElement () {
      const element = this.$refs.sound as HTMLDivElement

      if (element.parentElement && element.parentElement.parentElement) {
        element.parentElement.parentElement.style.display = 'none'
      }
    },
    shouldPlay (): boolean {
      return this.playCount < this.templateItemData.loop || this.templateItemData.loop === 0
    },
    playSound () {
      const audio = new Audio(this.templateItemData.mp3Uri)
      audio.addEventListener('ended', this.playSound)
      audio.play()
      this.$store.dispatch('commitAudio', audio)
      this.playCount++
    }
  }
})
